// @flow

import {
  CLEAR_MY_ARTIFACTS,
  FETCH_MY_ARTIFACTS_FAILURE,
  FETCH_MY_ARTIFACTS_REQUEST,
  FETCH_MY_ARTIFACTS_SUCCESS,
  SET_MY_ARTIFACTS_COURSE_FILTER
} from '../actions/myartifacts'

const initialState: {
  nextUrl: ?string,
  urlsDone: boolean,
  items: Array<Object>,
  isFetching: boolean,
  courseSectionId: number
} = {
  nextUrl: null,
  urlsDone: false,
  items: [],
  isFetching: false,
  courseSectionId: -1
}

export function myartifacts(
  state: Object = initialState,
  action: Object
): Object {
  switch (action.type) {
    case CLEAR_MY_ARTIFACTS: {
      return Object.assign({}, state, {
        nextUrl: null,
        urlsDone: false,
        items: [],
        isFetching: false
      })
    }

    case SET_MY_ARTIFACTS_COURSE_FILTER: {
      return Object.assign({}, state, {
        courseSectionId: action.courseSectionId,
        items: [],
        nextUrl: null,
        urlsDone: false
      })
    }

    case FETCH_MY_ARTIFACTS_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true
      })
    }

    case FETCH_MY_ARTIFACTS_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        items: [],
        nextUrl: null
      })

    case FETCH_MY_ARTIFACTS_SUCCESS:
      let items = Object.assign([], state.items)

      action.artifacts.forEach(item => {
        items.push(item)
      })

      return Object.assign({}, state, {
        isFetching: false,
        items: items,
        nextUrl: action.nextUrl,
        urlsDone: action.urlsDone
      })

    default:
      return state
  }
}
